import { Slide, Stack, Typography } from "@mui/material";
import { FC, forwardRef, ReactElement, Ref, useState } from "react";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import { TransitionProps } from "@mui/material/transitions";
import { setCookie } from "@/utils/clickAndCollect";
import { useSettings } from "@/data/Settings";
import { useLocalization } from "@/data/Localization";
import { parseHTML } from "@/utils/parseHTML";
import { Img } from "@/components/blocks/MaterialImage";
import { InfoPopupCloseIocnSX, popupContainerSX } from "../styles/registerInfoPopup";

export const RegisterInfoPopup: FC = () => {

    const { settings } = useSettings();

    const [open, setOpen] = useState(true);

    const popupLabelsNLS = useLocalization("RegistrationLayout").RegisterInfoPopup;

    const handleClose = () => {
        setCookie("USER_ACCOUNT_REGISTRATION_SUBMITTED", "false");
        setOpen(false);
    }

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            onClose={handleClose}
            aria-describedby={popupLabelsNLS.Heading.t()}
            maxWidth='sm'
            keepMounted={false}
            disableScrollLock
        >
            <CloseIcon
                aria-label="close"
                onClick={handleClose}
                sx={InfoPopupCloseIocnSX}
            />
            <DialogContent sx={{p:0}}>
                <Stack sx={popupContainerSX}>
                    <Stack alignSelf='center' height='100%' rowGap={2} p={2} justifyContent="center">
                        <Img src={`${settings.userData.StaticHostSecure}/wcsstore/logo-intertoys.png`} sx={{width:'50%', alignSelf:'center'}} />
                        <Typography variant='h2' sx={{ fontFamily: 'chaloops-medium' }}>
                            {parseHTML(popupLabelsNLS.Heading.t())}
                        </Typography>
                        <Typography>{parseHTML(popupLabelsNLS.InfoText1.t())}</Typography>
                        <Typography>{parseHTML(popupLabelsNLS.InfoText2.t())}</Typography>
                    </Stack>
                    <Stack justifyContent="center" direction="row">
                        <Img src={`${settings.userData.StaticHostSecure}/wcsstore/IntertoysSAS/images/pop-up-register-my-account.png`} />
                    </Stack>
                </Stack>
            </DialogContent>
        </Dialog>
    );
}

const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: ReactElement<any, any>;
    },
    ref: Ref<unknown>,
) {
    return <Slide direction="down" ref={ref} {...props} />;
});